const BASE = (process.env.REACT_APP_BACKEND_URL || "https://costruttori-pro.preview.emergentagent.com").replace(/\/$/, "");
const SITE = "Greenhouse Solutions SPA";

export const SEO_MAP = {
  "/": {
    title: `${SITE} — Impermeabilizzazione Poliurea & Coibentazione Poliuretano`,
    description: "Impresa edile in Puglia e in tutta Italia: ristrutturazioni chiavi in mano, impermeabilizzazione in poliurea, coibentazione in poliuretano, efficientamento energetico, pareti ventilate, rivestimenti e restauro.",
  },
  "/chi-siamo": {
    title: `Chi Siamo — ${SITE}`,
    description: "Materiali industriali applicati al residenziale. Scopri Greenhouse Solutions SPA: precisione tecnica, garanzie e un unico interlocutore per il tuo cantiere.",
  },
  "/servizi": {
    title: `Servizi — ${SITE}`,
    description: "Tutti i servizi tecnici di Greenhouse Solutions: poliurea, poliuretano, fotovoltaico, pareti ventilate, rivestimenti piscine, rivestimenti anticorrosivi, restauro conservativo e ristrutturazioni.",
  },
  "/impermeabilizzazione-poliurea": {
    title: `Impermeabilizzazione in Poliurea — ${SITE}`,
    description: "Membrana a spruzzo senza giunti, impermeabile in pochi secondi, elastica e durevole. Vantaggi, scheda tecnica e applicazioni della poliurea.",
  },
  "/coibentazione-poliuretano": {
    title: `Coibentazione in Poliuretano — ${SITE}`,
    description: "Isolamento termico ad alte prestazioni con poliuretano espanso a spruzzo: elimina i ponti termici e riduce i consumi. Vantaggi e applicazioni.",
  },
  "/efficientamento-energetico": {
    title: `Efficientamento Energetico & Fotovoltaico — ${SITE}`,
    description: "Impianti fotovoltaici ad alto rendimento per produrre energia pulita e abbattere i costi in bolletta. Efficientamento energetico su misura.",
  },
  "/pareti-ventilate": {
    title: `Pareti Ventilate — ${SITE}`,
    description: "Sistemi di facciata ventilata che isolano, proteggono l'edificio ed esaltano l'estetica. Vantaggi, scheda tecnica e applicazioni.",
  },
  "/rivestimenti-piscine": {
    title: `Rivestimenti per Piscine — ${SITE}`,
    description: "Innovativo rivestimento polimerico continuo e impermeabile per piscine nuove e da ripristinare. Estetica su misura e massima durata.",
  },
  "/rivestimenti-protettivi": {
    title: `Rivestimenti Protettivi Anticorrosivi — ${SITE}`,
    description: "Protezione conservativa e anticorrosiva tramite spruzzatura a fiamma di polveri termoplastiche. Film continuo ad altissima durata.",
  },
  "/restauro-conservativo": {
    title: `Restauro Conservativo — ${SITE}`,
    description: "Microaeroabrasione selettiva, pulitura e trattamento protettivo delle superfici storiche, nel pieno rispetto del materiale originale.",
  },
  "/ristrutturazioni-chiavi-in-mano": {
    title: `Ristrutturazioni Chiavi in Mano — ${SITE}`,
    description: "Ristrutturazione completa con un unico interlocutore: progettazione, cantiere, impianti e finiture. Tempi certi, budget chiaro, qualità garantita.",
  },
  "/finiture-e-rivestimenti": {
    title: `Finiture, Rivestimenti e Umidità di Risalita — ${SITE}`,
    description: "Pavimentazioni, intonaci, tinteggiature e rivestimenti di pregio per interni ed esterni, con trattamento dell'umidità di risalita a basso spessore e altamente traspirante. Finiture su misura coordinate con l'intero progetto.",
  },
  "/progetti": {
    title: `Progetti & Cantieri — ${SITE}`,
    description: "Alcuni dei nostri cantieri realizzati in Puglia e in tutta Italia: ristrutturazioni, impermeabilizzazioni, coibentazioni e rivestimenti.",
  },
  "/contatti": {
    title: `Contatti — ${SITE}`,
    description: "Contatta Greenhouse Solutions SPA a Monopoli (BA). Telefono, WhatsApp ed email per un sopralluogo o un preventivo gratuito in tutta Italia.",
  },
  "/preventivo": {
    title: `Richiedi un Preventivo — ${SITE}`,
    description: "Richiedi un preventivo gratuito e senza impegno. Descrivi il tuo intervento: ti ricontattiamo entro 24-48h per un sopralluogo.",
  },
  "/lavora-con-noi": {
    title: `Lavora con Noi — ${SITE}`,
    description: "Candidatura spontanea per operai e professionisti dell'edilizia. Unisciti a Greenhouse Solutions SPA: cantieri in tutta Italia, formazione tecnica e squadra affiatata.",
  },
  "/privacy": {
    title: `Informativa Privacy — ${SITE}`,
    description: "Come Greenhouse Solutions SPA raccoglie, utilizza e protegge i dati personali ai sensi del GDPR: preventivi, candidature, statistiche anonime, diritti dell'interessato.",
  },
};

export const OG_IMAGE = `${BASE}/images/og-cover.jpg`;
export const SEO_BASE = BASE;
export const SEO_SITE = SITE;
